import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type ComboPreviewType } from '@/defs/combo'
import { formatFullNumber } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatCommonFigure } from '../../StatCommon/StatCommonFigure/StatCommonFigure'

type Props = {
  combo: ComboPreviewType
}

export const StatComboRank = ({ combo }: Props) => {
  const { rank } = combo

  const popover = (
    <>
      <h2>
        <IconWithLabel iconBefore='chessKing'>Rank</IconWithLabel>
      </h2>
      <p>
        This combo is ranked <strong>#{formatFullNumber(rank)}</strong> in popularity among all combos.
      </p>
    </>
  )

  return (
    <StatCommonBox label='Rank' popover={popover}>
      <StatCommonFigure>#{formatFullNumber(rank)}</StatCommonFigure>
    </StatCommonBox>
  )
}
